import { render, staticRenderFns } from "./BusSingleSelector.vue?vue&type=template&id=0febed63&scoped=true&"
import script from "./BusSingleSelector.vue?vue&type=script&lang=js&"
export * from "./BusSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febed63",
  null
  
)

export default component.exports